<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="reward-view" v-if="giftList.length">
                        <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.id">
                                    <game-item :locked="true" :id="item.id" :num="item.send_num"></game-item>
                                </div>
                            </div>                              
                        </div>
                    </div>

                    <div class="msg-view">
                        <p>{{ text || '奖励已发放至游戏内军师邮件，请及时领取' }}</p>
                    </div>                    

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){
    .dialog-view{
        z-index: 100;
    }

    .msg-modal{
        width: 620px;
        height: 410px;
        background-image: url(~@/assets/images/modal/bg-modal-bind&reward.png);       
    }

    .title{
        width: 524px;
        height: 51px;
        margin: 0 auto 52px;
        background-image: url(~@/assets/images/modal/title-reward.png);
    }

    .msg-view{
        text-align: center;
        margin: 60px auto 0;
        font-size: 22px;
        color: #4b4846;
    }

    .u-btn.ok{
        position: absolute;
        left: 50%;
        bottom: 24px;
        transform: translateX(-50%);
        width: 207px;
        height: 55px;
        background-image: url(~@/assets/images/modal/btn-ok.png);                  

        @if ( $screenWidth == 1600) {
            &:hover{
                background-image: url(~@/assets/images/modal/btn-ok_hover.png);
            }
        }
    }
    
    .reward-view{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 56px;
        margin: 20px 0 20px;
    }

    .reward-item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 84px;
        height: 84px;
        margin: 0 19px;
        border: 1px solid #d1c7b4;
        background-color: #e6ddcc;
    }

    .r-wrapper{
        width: 68px;
        height: 68px;
    }

    .r-wrapper>.pic{
        width: 100%;
        height: 100%;
    }    

}


@media screen and (min-width: 1000px){
    @include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
    @include boxStyle( 1000 );
}   
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 1,
            giftList : [{id : 'A001',send_num : 10,}],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/RewardModal/successModal.vue